import Vue from 'vue'
import Vuex from 'vuex'
import { 
    authModule,
    userModule,
    addressModule,
    shebaNumberModule,
    gatewayModule,
    ticketModule,
    storeModule,
    productModule,
    pardakhtShakhsiModule,
    notificationModule,
    notificationSmsModule,
    verifyMailModule,
    cartModule,
    shaparakModule,
    pspRequestModule,
    dashboardModule,
    settlementModule,
    paymanModule,
    ivrModule,
    dedicatedModule,
    transactionModule,
    newsModule,
    collectiveModule,
    marketingModule,
    allotmentModule,
    blackListModule,
    badgeCounterModule,
    reportsModule,
    moneyRequestModule,
    onlineFactorModule,
    walletModule,
} from './modules'
import { abilityPlugin } from '@/common/ability'
import CardToCardModule from "./modules/cardToCardModule";
import onlineContractModule from '@/store/modules/onlineContractModule';

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        abilityPlugin
    ],
    modules: {
        auth: authModule,
        user: userModule,
        address: addressModule,
        shebaNumber: shebaNumberModule,
        gateway: gatewayModule,
        ticket: ticketModule,
        store: storeModule,
        product: productModule,
        pardakhtShakhsi: pardakhtShakhsiModule,
        notification: notificationModule,
        notificationSms:notificationSmsModule,
        verifyMail: verifyMailModule,
        cart:cartModule,
        shaparak: shaparakModule,
        pspRequest: pspRequestModule,
        dashboard: dashboardModule,
        settlement: settlementModule,
        payman: paymanModule,
        ivr: ivrModule,
        dedicated: dedicatedModule,
        transaction: transactionModule,
        news: newsModule,
        collective: collectiveModule,
        marketing: marketingModule,
        allotment: allotmentModule,
        blackList: blackListModule,
        badgeCounter: badgeCounterModule,
        reports: reportsModule,
        moneyRequest: moneyRequestModule,
        onlineFactor: onlineFactorModule,
        wallet: walletModule,
        cardToCard: CardToCardModule,
        onlineContract: onlineContractModule
    },
})
